var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const getClient = (baseUrl) => {
    const options = {
        baseURL: baseUrl
    };
    const client = axios.create(options);
    client.interceptors.request.use(config => {
        var _a, _b;
        if (((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.csrf_token) && ((_b = window === null || window === void 0 ? void 0 : window.app) === null || _b === void 0 ? void 0 : _b.csrf_timestamp)) {
            config.headers.common['csrf_token'] = window.app.csrf_token;
            config.headers.common['csrf_timestamp'] = window.app.csrf_timestamp;
        }
        return config;
    });
    client.interceptors.response.use(response => response, (error) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            const datadogRum = window.DD_RUM;
            if (datadogRum) {
                datadogRum.addUserAction('Dyson: Unauthorized Error', { error });
            }
        }
        return Promise.reject(error);
    }));
    return client;
};
class ApiClient {
    constructor(baseUrl) {
        this.baseURL = baseUrl || '';
        this.client = getClient(baseUrl);
    }
    get(url, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.get(url, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    }
    delete(url, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.delete(url, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    }
    post(url, data = {}, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(url, data, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    }
    put(url, data = {}, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.put(url, data, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    }
    patch(url, data = {}, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.patch(url, data, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    }
}
export { ApiClient };
export default {
    get(url, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield getClient().get(url, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    },
    delete(url, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield getClient().delete(url, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    },
    post(url, data = {}, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield getClient().post(url, data, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    },
    put(url, data = {}, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield getClient().put(url, data, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    },
    patch(url, data = {}, config = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield getClient().patch(url, data, config);
                return yield Promise.resolve(response);
            }
            catch (error) {
                return yield Promise.reject(error);
            }
        });
    }
};
